import { render } from "./CustomButton_old.vue?vue&type=template&id=55090b44&scoped=true"
import script from "./CustomButton_old.vue?vue&type=script&lang=js"
export * from "./CustomButton_old.vue?vue&type=script&lang=js"

import "./CustomButton_old.vue?vue&type=style&index=0&id=55090b44&scoped=true&lang=css"

import exportComponent from "/Users/matt/Dev/convict-memorial-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55090b44"]])

export default __exports__